module.exports = __webpack_public_path__ + "img/telecom_balance.4fc01757.png";